/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slider = __webpack_require__(1);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.addEventListener('load', function () {
	  var imageSlider = new _slider2.default('.aside');
	  var $slider = document.querySelector('.aside');
	  var $galleryThumbs = document.querySelectorAll('.product__link');
	
	  $slider.querySelector('.gallery__prev').addEventListener('click', function () {
	    imageSlider.prev();
	  });
	  $slider.querySelector('.gallery__next').addEventListener('click', function () {
	    imageSlider.next();
	  });
	
	  for (var i = 0; i < $galleryThumbs.length; i++) {
	    $galleryThumbs[i].addEventListener('click', function (e) {
	      imageSlider.open();
	      imageSlider.goto(e.currentTarget.getAttribute('data-id'));
	    });
	  }
	
	  document.querySelector('.gallery__close').addEventListener('click', function (e) {
	    imageSlider.close();
	  });
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Slider = function () {
	    function Slider(selector) {
	        _classCallCheck(this, Slider);
	
	        if (!selector) selector = '.slider';
	        this.slider = document.querySelector(selector);
	        this.activeSlide = this.slider.querySelector('.active');
	    }
	
	    _createClass(Slider, [{
	        key: 'prev',
	        value: function prev() {
	            this.activeSlide.classList.remove('active');
	            this.activeSlide = this.activeSlide.previousElementSibling.classList.contains('gallery__image') ? this.activeSlide.previousElementSibling : this.slider.querySelector('.gallery__image:last-child');
	            this.activeSlide.classList.add('active');
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            this.activeSlide.classList.remove('active');
	            this.activeSlide = this.activeSlide.nextElementSibling ? this.activeSlide.nextElementSibling : this.slider.querySelector('.gallery__image');
	            this.activeSlide.classList.add('active');
	        }
	    }, {
	        key: 'goto',
	        value: function goto(id) {
	            if (this.activeSlide) this.activeSlide.classList.remove('active');
	            this.activeSlide = document.getElementById(id);
	            this.activeSlide.classList.add('active');
	        }
	    }, {
	        key: 'open',
	        value: function open() {
	            this.slider.classList.add('off');
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            if (this.activeSlide) this.activeSlide.classList.remove('active');
	            this.slider.classList.remove('off');
	        }
	    }]);
	
	    return Slider;
	}();
	
	exports.default = Slider;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// app.js